/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Editor_CountInputs */

const tr_landing_pricerules_mock_editor_count = /** @type {(inputs: Landing_Pricerules_Mock_Editor_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 kural · 4 aktif`)
};

const en_landing_pricerules_mock_editor_count = /** @type {(inputs: Landing_Pricerules_Mock_Editor_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 rules · 4 active`)
};

const de_landing_pricerules_mock_editor_count = /** @type {(inputs: Landing_Pricerules_Mock_Editor_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Regeln · 4 aktiv`)
};

const ru_landing_pricerules_mock_editor_count = /** @type {(inputs: Landing_Pricerules_Mock_Editor_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 правил · 4 активны`)
};

/**
* | output |
* | --- |
* | "5 rules · 4 active" |
*
* @param {Landing_Pricerules_Mock_Editor_CountInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_editor_count = /** @type {((inputs?: Landing_Pricerules_Mock_Editor_CountInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Editor_CountInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_editor_count(inputs)
	if (locale === "de") return de_landing_pricerules_mock_editor_count(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_editor_count(inputs)
	return tr_landing_pricerules_mock_editor_count(inputs)
});